export const createChunkRequest = (file, chunkSize = 2000000) => {
    return JSON.stringify({filename: file.name, totalChunks: calculateTotalChunks(file.size, chunkSize)})
}

export const getChunksFromFile = (file, chunkSize = 2000000) => {
    let totalChunks = calculateTotalChunks(file.size, chunkSize)
    let fileChunks = []
    for (let i = 0; i < totalChunks; i++) {
        if (i === totalChunks - 1) {
            fileChunks.push(file.slice(i*chunkSize))
        } else {
            fileChunks.push(file.slice(i*chunkSize,(i*chunkSize)+chunkSize))
        }
    }
    return fileChunks
}

const calculateTotalChunks = (fileSize, chunkSize = 2000000) => {
    return fileSize % chunkSize === 0 ? 
        fileSize / chunkSize :
        Math.floor(fileSize / chunkSize) + 1
}

export const convertChunkToBase64 = chunk => new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(chunk)
    reader.onload = () => resolve(reader.result.replace('data:application/octet-stream;base64,',''))
    reader.onerror = error => reject(error)
})